<template>
  <a class="c-article-card" :href="item.url">
    <div
      class="c-article-card__image"
      :style="{ backgroundImage: `url(${item.image})` }"
    ></div>
    <div class="c-article-card__text">
      <time class="c-article-card__time" :datetime="item.publishedAt">
        {{ item.publishedAtText }}
      </time>
      <div class="c-article-card__tags" v-if="item.tags.length">
        <span
          v-for="tag in item.tags"
          :key="tag"
          class="c-article-card__tag"
          @click.stop.prevent="$emit('tag-clicked', tag)"
        >
          {{ tag }}
        </span>
      </div>
      <h3 class="c-article-card__title">
        {{ item.title }}
      </h3>
    </div>
  </a>
</template>

<script>
import { Article } from '~/js/models/article'
export default {
  name: 'ComponentArticleCard',
  props: {
    item: {
      type: Article,
      required: true,
      default: () => {
        return new Article()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';

.c-article-card {
  display: flex;

  &__image {
    background-position: center;
    background-size: 96px;
    border: 1px solid variables.$color-text-gray;
    border-radius: 12px;
    flex-shrink: 0;
    height: 96px;
    width: 96px;
  }

  &__text {
    margin-left: 28px;
    padding: 4px 0;
  }

  &__time {
    font-size: 12px;
    font-weight: 300;
    margin-right: 12px;
  }

  &__tags {
    display: inline-block;
  }

  &__tag {
    background-color: variables.$color-pink;
    border-radius: 9px;
    display: inline-block;
    font-size: 10px;
    line-height: 18px;
    margin-right: 4px;
    padding: 0 8px;
    text-transform: uppercase;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    margin-top: 4px;
  }
}
</style>
